export default __webpack_public_path__ + "static/media/upcoming batch 2.b4852e3d.png";